module.exports = __webpack_public_path__ + "static/media/nanjing-woyuan.b9afd025.svg";